module.exports = __webpack_public_path__ + "img/attach.a0b0993d.svg";